import { render } from "./asset-edit.vue?vue&type=template&id=6ea4ac76&scoped=true"
import script from "./asset-edit.vue?vue&type=script&lang=js"
export * from "./asset-edit.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-6ea4ac76"

export default script